export default {"src":"/_next/static/media/code_editor.bfc45f94.svg","height":51,"width":50,"blurWidth":0,"blurHeight":0};